<template>
  <div>
    <v-container v-if="!loadingChart">
      <v-row align="center">
        <pie-chart
          v-if="chartType === 'pie'"
          style="margin: auto; position: relative; width:95%; height:28vh"
          :chart-data="chartData"
          :options="chartOptions"
        />
      </v-row>
      <log-dialog
        :headers="headers"
        :logData="logData"
        :showDialog="showDialog"
        :title="dialogTitle"
        :isLoading="loading"
        :csvFilename="csvFilename"
        :courseId="course.id"
      />
    </v-container>
  </div>
</template>

<script>
import PieChart from './PieChart.vue'
import LogDialog from './LogDialog.vue'
import {
  variablesTableHeader,
  TOTAL_ITEMS,
  sortDataByDate,
  getRandomColorFromList,
  Multiset
} from '../Constants'
import _ from 'lodash'

export default {
  props: {
    variables: {
      type: Array,
      required: true
    },
    course: {
      type: Object,
      required: true
    },
    variableName: {
      type: String,
      required: false
    },
    agent: {
      type: String,
      required: false,
      default: null
    },
    chartStyle: {
      type: Object,
      default: null,
      required: false
    }
  },
  components: {
    LogDialog,
    PieChart
  },
  data() {
    return {
      chartData: {},
      chartOptions: {},
      loading: true,
      loadingChart: false,
      headers: [],
      logData: [],
      showDialog: false,
      dialogTitle: '',
      csvFilename: '',
      labelMaxLenght: 15,
      chartType: 'pie',
      userHeaders: [
        { text: 'Name', value: 'name' },
        { text: 'Value', value: 'value' }
      ],
      items: []
    }
  },
  mounted() {
    this.loadingChart = true
    this.fillChartData()
    this.loadingChart = false
  },
  methods: {
    onClickChoice(event, array) {
      if (array.length > 0) {
        this.logData = []
        const label = array[0]._chart.tooltip._data.labels[array[0]._index]
        const metadata = array[0]._chart.tooltip._data.metadata
        const courseName = this.course.name.replace(/\s+/g, '_')
        this.dialogTitle = label
        this.headers = variablesTableHeader
        this.csvFilename = courseName + '_variables_log'
        this.loading = true
        this.showDialog = true

        metadata.forEach(element => {
          if (element.value == label) {
            this.logData.push(element)
          }
        })

        this.logData = sortDataByDate(this.logData)
        this.loading = false
      }
    },
    fillPieChart() {
      let labels = new Array()
      let metadata = new Array()
      let data = new Array()
      let backgroundColor = new Array()

      let map = new Multiset()
      for (let key in this.variables) {
        map.add(this.variables[key].value)
        metadata.push(this.variables[key])
      }

      for (const [key, value] of map.entries()) {
        let label = key
        if (key.length > this.labelMaxLenght) {
          label = label.substr(0, this.labelMaxLenght) + '...'
        }
        labels.push(label)
        data.push(value)
        backgroundColor.push(getRandomColorFromList())
      }

      this.chartOptions = {
        hover: {
          onHover: function(e) {
            e.target.style.cursor = 'pointer'
          }
        },
        onClick: this.onClickChoice,
        legend: {
          display: true,
          position: 'left',
          align: 'center'
        },
        tooltips: {
          callbacks: {
            title: function(tooltipItem, data) {
              let label = data['labels'][tooltipItem[0]['index']]
              const metadata = data['metadata']
              if (label.length > 15) {
                label = label.replace('...', '')
                if (metadata) {
                  const val = metadata.find(val => val.value.includes(label))
                  if (val) {
                    label = val.value
                  }
                }
              }
              return label
            },
            label: function(tooltipItem, data) {
              let label = data['labels'][tooltipItem['index']]
              const metadata = data['metadata']

              if (label.length > 15) {
                label = label.replace('...', '')
                if (metadata) {
                  const val = metadata.find(val => val.value.includes(label))
                  if (val) {
                    label = val.value
                  }
                }
              }
              let toolTip = new Array()
              if (metadata) {
                metadata.forEach(element => {
                  if (toolTip.length < TOTAL_ITEMS && element.value == label) {
                    toolTip.push(element.user)
                  }
                })

                if (toolTip.length > TOTAL_ITEMS) {
                  const diff = toolTip.length - TOTAL_ITEMS
                  toolTip.push(`and ${diff} more`)
                }
              }
              return toolTip
            }
          },
          backgroundColor: '#FFF',
          titleFontSize: 10,
          titleFontColor: '#000',
          bodyFontColor: '#000',
          bodyFontSize: 12,
          displayColors: false,
          borderWidth: 0.2,
          borderColor: '#000',
          hoverBorderColor: '#000',
          hoverBorderWidth: 10
        },
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 30,
        animation: {
          animateRotate: true,
          animateScale: true
        },
        legend: {
          position: 'left'
        },
        title: {
          display: true,
          text: this.variableName
        }
      }

      this.chartData = {
        labels: labels,
        metadata: metadata,
        datasets: [
          {
            label: this.variableName,
            backgroundColor: backgroundColor,
            data: data
          }
        ]
      }
    },
    fillChartData() {
      this.chartType = 'pie'
      return this.fillPieChart()
    }
  }
}
</script>

<style></style>
